export default __webpack_public_path__ + "static/media/lock.50e012e3.svg";